import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../Dashboard";

export const organisationAdminRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "organisation-admin",
}).lazy(() => import("./OrganisationAdmin.lazy").then((d) => d.Route));
